<template>
  <div class="care">
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <div class="row">
          <div
            class="col-xl-1 col-lg-2 col-md-2 col-sm-12 col-12 pt-1 d-flex align-items-center"
          >
            <v-btn class="btn-return mt-2" v-on:click="handleToBack">
              <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
            </v-btn>
          </div>
          <div
            class="col-xl-11 col-lg-10 col-md-10 col-sm-12 col-12 d-flex justify-content-between"
          >
            <h1 class="title-pages mt-1">{{ handleType(care.type) }}</h1>
          </div>
        </div>
        <div>
          <Annotation
            :id="id"
            :care="care"
            :rest_home_id="rest_home_id"
            :resident_id="care.resident_id"
            :resident_name="care.resident_name"
            :resident_type_of_food="care.resident_type_of_food"
            :user="user"
            :createdAt="createdAt"
            :statusCare="care.status"
            v-on:change="retrieve()"
          />

          <LinkVerLocalizacaoRegistro :item="care" />
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import LinkVerLocalizacaoRegistro from "../templates/Components/LinkVerLocalizacaoRegistro";

import Annotation from "../templates/Care/NursingCaregiver/View/Annotation";

import api from "../services/api";

import routes from "../routes";

import { userData, getStatic } from "../lib/functions";

export default {
  name: "Care",
  components: {
    NavBar,
    AuthBySessionExpired,
    Annotation,
    LinkVerLocalizacaoRegistro,
  },
  data() {
    return {
      accessed_offline: false,
      active: "vital_signs",
      rest_home_id: "",
      id: "",
      care: {},
      user: {},
      createdAt: true,
      loading: true,
      render: true,
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    handleType(type) {
      var show = {
        CUIDADOR_ENFERMAGEM: "Cuidador/Enfermagem",
        ENFERMEIRA: "Enfermeira",
        MEDICO: "Médico",
        EQUIPE_MULTIDISCIPLINAR: "Equipe Multidisciplinar",
        default: "Tipo não encontrado!",
      };

      return show[type] || show.default;
    },
    async retrieve() {
      const { user } = userData();

      this.rest_home_id = user.rest_home_id;

      this.user = user;

      const { id, active } = routes.history.current.params;

      this.id = id;

      if (active) {
        if (["vital_signs", "annotation"].includes(active)) {
          this.active = active;
        }
      }

      let accessed_offline = JSON.parse(
        sessionStorage.getItem("accessed_offline") || !this.$store.state.online
      );

      this.accessed_offline = accessed_offline;

      if (accessed_offline) {
        try {
          let residents = (
            await getStatic("/offline/residents/annotations", true)
          ).residents;

          let annotations = [];
          for (let resident of residents) {
            annotations.push(...resident.annotations);
          }

          let care = annotations.filter((item) => item.id == id);

          if (care[0]) {
            this.care = care[0];
            this.createdAt = false;
          }
        } catch (errors) {
          this.errors = errors;
        }
        this.loading = false;
      } else {
        await this.get();
      }
    },
    async get() {
      try {
        this.loading = true;

        let { id } = this;

        var params = {
          id,
        };

        const response = await api.get("/rest-home/care/get", {
          params,
        });

        const { error, care, createdAt } = response.data;

        if (error) {
          return routes.go(-1);
        }

        this.care = care;
        this.createdAt = createdAt;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleToBack: () => routes.go(-1),
  },
};
</script>

<style>
.care .ssvv-top {
  width: 50%;
  text-align: center;
  text-transform: uppercase;
  color: #000;
  font-weight: 600;
}

.care .nav-tabs .nav-link.active {
  background-color: #1f5a76;
  color: #fff;
  border-color: #1f5a76;
}
</style>
